import { ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { Link } from "react-router-dom";

import SideBarSubMenu from "components/Navigation/SideBarSubMenu";

import styles from "./SidebarItem.module.css";

const SidebarItem = ({
    icon: Icon,
    label,
    link,
    isActive,
    hasSubItems,
    subItems,
    subItemsLabel,
    isExternal,
}) => {
    return (
        <div
            className={styles.SidebarItemWrapper}
            data-testid={`sidebar-item-${label.toLowerCase().replace(/\s/g, "-")}`}
        >
            {label === "Support" && <hr className={styles.Sidebar_Divider} />}
            <ListItemButton
                component={isExternal ? "a" : Link}
                to={isExternal ? undefined : link}
                href={isExternal ? link : undefined}
                target={isExternal ? "_blank" : undefined}
                rel={isExternal ? "noopener noreferrer" : undefined}
                className={`${styles.SidebarItem} ${isActive ? styles.SidebarItem_Active : ""}`}
            >
                {Icon && (
                    <ListItemIcon className={styles.SidebarItem_Icon}>
                        <Icon />
                    </ListItemIcon>
                )}
                <ListItemText
                    className={styles.SidebarItem_Text}
                    primary={label}
                />
            </ListItemButton>
            {hasSubItems && (
                <div className={styles.SubMenuPopout}>
                    <SideBarSubMenu title={subItemsLabel}>
                        {subItems.map((subItem, index) => (
                            <SidebarItem
                                key={index}
                                icon={subItem.icon}
                                label={subItem.label}
                                link={subItem.link}
                                isActive={subItem.isActive}
                                isExternal={subItem.isExternal}
                            />
                        ))}
                    </SideBarSubMenu>
                </div>
            )}
            {label === "Home" && <hr className={styles.Sidebar_Divider} />}
        </div>
    );
};

export default SidebarItem;
